import React, { useMemo, useState, useCallback, useEffect } from "react";

import { Modal, ModalProps } from "react-bootstrap";
import { ActionMeta, Options, SingleValue } from "react-select";
import { DateObject } from "react-multi-date-picker";
import CreateSelect from "react-select/creatable";
import Select from "react-select";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";

import Tabs from "../tab/Tabs";
import { CustomInput } from "../kits/Inputs/Inputs";
import DatePiker from "../datepiker/datePiker";
import CustomButton from "../kits/button/CustomButton";

import TransactionList from "./TransactionList";

import {
  CardType,
  CreateTransactionRequestType,
  FindBankAccountRequestType,
  FindBankAccountResponseType,
  InsertBankAccountRequestType,
  InsertResponseType,
  ReactSelectOptionType,
  ResponseType,
} from "./FiMaTypes";
import {
  SelectedCustomerType,
  TransactionModalsTypes,
} from "./FinancialContext";
import { OptionType } from "../single-campaign/SiCaTypes";
import useAxios from "../../services/useAxios";
import { apiResponseHandler } from "../single-campaign/SiCahelper";

interface DetailModalProps {
  show: number;
  selectedCustomer: SelectedCustomerType;
  setShow: React.Dispatch<React.SetStateAction<number>>;
}

const DetailModal: React.FC<DetailModalProps> = ({
  show,
  selectedCustomer,
  setShow,
}) => {
  const navItem = useMemo(
    () => [
      { title: "لیست تراکنش‌ها", target: "#nav-pill-financial-customer-tab" },
      {
        title: "لیست صورت‌حساب‌ها",
        target: "#nav-pill-financial-transactions-tab",
      },
    ],
    []
  );
  const tabContent = useMemo(
    () => [
      {
        id: "nav-pill-financial-customer-tab",
        component: (
          <div
            style={{
              width: "100%",
            }}
          >
            <TransactionList transactions={selectedCustomer.transactions} />
          </div>
        ),
      },
      {
        id: "nav-pill-financial-transactions-tab",
        component: (
          <div
            style={{
              width: "100%",
            }}
          >
            {/* TODO: */}
            در اینجا صورت‌حساب‌ها قرار می‌گیرد.
          </div>
        ),
      },
    ],
    [selectedCustomer.transactions]
  );

  return (
    <Modal
      show={show === TransactionModalsTypes.DetailModal}
      onHide={() => setShow(TransactionModalsTypes.Close)}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>{selectedCustomer.info.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Tabs
          className=""
          navItem={navItem}
          type="horizontal"
          myFunction={() => {}}
          tabContent={tabContent}
        />
      </Modal.Body>
    </Modal>
  );
};

interface TransactionModalProps {
  show: number;
  customer_id: number;
  banks: ReactSelectOptionType[];
  setShow: React.Dispatch<React.SetStateAction<number>>;
}

const TransactionModal: React.FC<TransactionModalProps> = ({
  show,
  customer_id,
  banks,
  setShow,
}) => {
  // API Connections
  const { execute: findBankAccountAPI } = useAxios("api/Find_BankAccount");
  const { execute: InsertBankAccountAPI } = useAxios("api/Insert_BankAccount");
  const { execute: createTransactionAPI } = useAxios("api2/create_transaction");

  // states
  const [userCards, setUserCards] = useState<CardType[]>([]);
  const [adminCards, setAdminCards] = useState<CardType[]>([]);

  // add card inputs' values
  const [addCardInput, setAddCardInput] = useState<
    CardType & {
      shebaNumberError: string;
      cardNumberError: string;
    }
  >({
    id: 0,
    accountNumber: "",
    bankId: 0,
    customerId: 0,
    shebaNumber: "",
    shebaNumberError: "",
    cardNumber: "",
    cardNumberError: "",
    status: 0,
  });

  // add transaction inputs' values
  const [addTransactionInput, setAddTransactionInput] = useState<{
    price: number;
    payTimestamp: DateObject;
    fromCardId: number;
    toCardId: number;
    priceHasError: boolean;
  }>({
    price: 0,
    payTimestamp: new DateObject(),
    fromCardId: 0,
    toCardId: 0,
    priceHasError: false,
  });

  // from account cards
  const fromCards = useMemo<Options<OptionType>>(() => {
    let cards = [];
    cards.push(
      ...userCards.map((c) => {
        let bankName = "",
          bank = banks.find((b) => +c.bankId === +b.value);
        if (bank) {
          bankName = ` (${bank.label})`;
        }
        return {
          label: `${c.accountNumber}${bankName}`,
          value: "" + c.id,
        };
      })
    );
    cards.push(
      ...adminCards.map((c) => {
        let bankName = "",
          bank = banks.find((b) => +c.bankId === +b.value);
        if (bank) {
          bankName = ` (${bank.label})`;
        }
        return {
          label: `${c.accountNumber}${bankName} ((ادمین))`,
          value: "" + c.id,
        };
      })
    );
    return cards;
  }, [userCards, adminCards, banks]);

  // to account cards will fill when from account card is selected.
  const toCards = useMemo<Options<OptionType>>(() => {
    let cards: Options<OptionType> = [];
    if (addTransactionInput.fromCardId !== 0) {
      if (userCards.find((c) => +c.id === +addTransactionInput.fromCardId)) {
        //   if (+card.customerId === 0) {
        //     return mainCards.filter((c) => +c.customerId !== 0);
        //   }
        //   return mainCards.filter((c) => +c.customerId === 0);
        cards = adminCards.map((c) => {
          let bankName = "",
            bank = banks.find((b) => +c.bankId === +b.value);
          if (bank) {
            bankName = ` (${bank.label})`;
          }
          return {
            label: `${c.accountNumber}${bankName} ((ادمین))`,
            value: "" + c.id,
          };
        });
      } else if (
        adminCards.find((c) => +c.id === +addTransactionInput.fromCardId)
      ) {
        cards = userCards.map((c) => {
          let bankName = "",
            bank = banks.find((b) => +c.bankId === +b.value);
          if (bank) {
            bankName = ` (${bank.label})`;
          }
          return {
            label: `${c.accountNumber}${bankName}`,
            value: "" + c.id,
          };
        });
      }
    }
    return cards;
  }, [addTransactionInput.fromCardId, userCards, adminCards, banks]);

  const getCards = useCallback(() => {
    const data: FindBankAccountRequestType = {
      conditions: `customer_id/=/${customer_id}`,
    };
    findBankAccountAPI(data).then((res: FindBankAccountResponseType) => {
      setUserCards(
        res.map((val) => ({
          id: +val.id,
          accountNumber: val.account_number,
          bankId: +val.bank_id,
          customerId: +val.customer_id,
          shebaNumber: val.sheba_number,
          cardNumber: val.card_number,
          status: +val.status,
        }))
      );
    });
  }, [banks, customer_id]);

  // Add Transaction Modal Handlers
  const priceInputHandler = useCallback<
    React.ChangeEventHandler<HTMLInputElement>
  >((event) => {
    const price = removeCommas(event.target.value);
    setAddTransactionInput((prev) => ({
      ...prev,
      price: price,
      priceHasError: price <= 0,
    }));
  }, []);

  const payTimestampInputHandler = useCallback(
    (event: DateObject | DateObject[] | null) => {
      if (event instanceof DateObject) {
        setAddTransactionInput((prev) => ({
          ...prev,
          payTimestamp: event,
        }));
      }
    },
    []
  );

  const fromCardSelectHandler = useCallback(
    (newValue: SingleValue<OptionType>, action: ActionMeta<OptionType>) => {
      if (action.action === "create-option") {
        setShow(TransactionModalsTypes.AddCard);
      } else {
        setAddTransactionInput((prev) => ({
          ...prev,
          fromCardId: newValue?.value ? +newValue.value : 0,
          toCardId: 0,
        }));
      }
    },
    [setShow]
  );

  const toCardSelectHandler = useCallback(
    (newValue: SingleValue<OptionType>, action: ActionMeta<OptionType>) => {
      if (action.action === "create-option") {
        setShow(TransactionModalsTypes.AddCard);
      } else {
        setAddTransactionInput((prev) => ({
          ...prev,
          toCardId: newValue?.value ? +newValue.value : 0,
        }));
      }
    },
    [setShow]
  );

  const submitTransaction = useCallback<
    React.MouseEventHandler<HTMLButtonElement>
  >(
    (event) => {
      event.preventDefault();

      let fromCard = [...adminCards].find(
        (c) => +c.id === +addTransactionInput.fromCardId
      );
      let type = "0";
      if (fromCard) {
        type = "1";
      }

      const data: CreateTransactionRequestType = {
        count: "" + addTransactionInput.price,
        customer_id: "" + customer_id,
        from_account_id: "" + addTransactionInput.fromCardId,
        to_account_id: "" + addTransactionInput.toCardId,
        paid_tm: "" + addTransactionInput.payTimestamp.unix,
        type,
      };

      createTransactionAPI(data).then((res: ResponseType) => {
        apiResponseHandler(res, {
          success: "تراکنش با موفقیت ایجاد گردید.",
          failure:
            "مشکلی در ارتباط با سرور اتفاق افتاده است، لطفا مجددا تلاش کنید.",
        });
        if (+res.status === 1) {
          setShow(TransactionModalsTypes.Close);
        }
      });
    },
    [addTransactionInput, customer_id, adminCards, setShow]
  );

  // Add Card Modal Handlers
  const AccountNumberInputHandler = useCallback<
    React.ChangeEventHandler<HTMLInputElement>
  >((event) => {
    setAddCardInput((prev) => ({
      ...prev,
      accountNumber: event.target.value,
    }));
  }, []);

  const cardNumberInputHandler = useCallback<
    React.ChangeEventHandler<HTMLInputElement>
  >((event) => {
    setAddCardInput((prev) => ({
      ...prev,
      cardNumber: event.target.value,
    }));
  }, []);

  const shebaNumberInputHandler = useCallback<
    React.ChangeEventHandler<HTMLInputElement>
  >((event) => {
    setAddCardInput((prev) => ({
      ...prev,
      shebaNumber: event.target.value,
    }));
  }, []);

  const bankSelectHandler = useCallback(
    (newValue: SingleValue<OptionType>, action: ActionMeta<OptionType>) => {
      setAddCardInput((prev) => ({
        ...prev,
        bankId: newValue ? +newValue.value : 0,
      }));
    },
    []
  );

  const backButton = useCallback(() => {
    setShow(TransactionModalsTypes.Close);
  }, [setShow]);

  const addCardBackButton = useCallback(() => {
    setShow(TransactionModalsTypes.AddTransaction);
  }, [setShow]);

  const submitCard = useCallback<React.MouseEventHandler<HTMLButtonElement>>(
    (event) => {
      event.preventDefault();

      let shebaNumberError = "",
        cardNumberError = "";
      if (!/^\d{24}$/.test(addCardInput.shebaNumber)) {
        shebaNumberError = "لطفا شماره شبا را به درستی وارد نمایید.";
      }
      if (!/^\d{16}$/.test(addCardInput.cardNumber)) {
        cardNumberError = "لطفا شماره کارت را به درستی وارد نمایید.";
      }

      if (shebaNumberError !== "" || cardNumberError !== "") {
        setAddCardInput((prev) => ({
          ...prev,
          shebaNumberError,
          cardNumberError,
        }));
        return;
      }

      const data: InsertBankAccountRequestType = {
        customer_id: "" + customer_id,
        account_number: addCardInput.accountNumber,
        bank_id: "" + addCardInput.bankId,
        sheba_number: addCardInput.shebaNumber,
        card_number: addCardInput.cardNumber,
        status: "1",
      };

      InsertBankAccountAPI(data).then((res: InsertResponseType) => {
        if (Boolean(res.status)) {
          getCards();
          setShow(TransactionModalsTypes.AddTransaction);
          setAddCardInput({
            id: 0,
            accountNumber: "",
            bankId: 0,
            cardNumber: "",
            customerId: 0,
            cardNumberError: "",
            shebaNumber: "",
            shebaNumberError: "",
            status: 0,
          });
        }
      });
    },
    [addCardInput, customer_id, getCards, setShow]
  );

  useEffect(() => {
    getCards();
    const data: FindBankAccountRequestType = {
      conditions: "customer_id/=/0",
    };
    findBankAccountAPI(data).then((res: FindBankAccountResponseType) => {
      setAdminCards(
        res.map((val) => ({
          id: +val.id,
          accountNumber: val.account_number,
          bankId: +val.bank_id,
          customerId: +val.customer_id,
          shebaNumber: val.sheba_number,
          cardNumber: val.card_number,
          status: +val.status,
        }))
      );
    });
  }, [customer_id, getCards]);

  useEffect(() => {
    if (show === TransactionModalsTypes.Close) {
      setAddTransactionInput({
        price: 0,
        payTimestamp: new DateObject(),
        fromCardId: 0,
        toCardId: 0,
        priceHasError: false,
      });
    }
    if (show === TransactionModalsTypes.AddCard) {
      setAddCardInput({
        id: 0,
        accountNumber: "",
        bankId: 0,
        customerId: 0,
        shebaNumber: "",
        shebaNumberError: "",
        cardNumber: "",
        cardNumberError: "",
        status: 0,
      });
    }
  }, [show]);

  return (
    <>
      <Modal
        show={show === TransactionModalsTypes.AddTransaction}
        onHide={() => setShow(TransactionModalsTypes.Close)}
      >
        <Modal.Header closeButton>
          <Modal.Title>افزودن تراکنش</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="pb-3">
            <CustomInput
              inputContainer="mb-3"
              label="مبلغ تراکنش"
              textErr={
                addTransactionInput.priceHasError
                  ? "لطفا مبلغ را به درستی وارد کنی."
                  : ""
              }
              inputValue={addCommas(addTransactionInput.price)}
              // @ts-ignore
              onChangeFunc={priceInputHandler}
            />
            <div className="mb-3">
              <label
                className="form-label"
                style={{
                  color: "#677788",
                  fontSize: "0.75rem",
                }}
              >
                زمان پرداخت
              </label>

              <DatePiker
                value={addTransactionInput.payTimestamp}
                setValue={payTimestampInputHandler}
                type_calender=""
                location=""
                color=""
                bg=""
                buttons=""
                time=""
                just_time=""
                onlyYear=""
                onlyMonth=""
                hideWeekDays=""
                hideMonth=""
                highlightDay=""
                color_highlight=""
                disableDay=""
                weekend=""
                disableYearPicker=""
                disableMonthPicker=""
                plugins=""
                mood=""
                inputSize=""
              />
            </div>
            <div className="mb-3">
              <label
                className="form-label"
                style={{
                  color: "#677788",
                  fontSize: "0.75rem",
                }}
              >
                کارت بانکی مربوطه
              </label>
              <CreateSelect
                value={
                  fromCards.filter(
                    (c) => +c.value === +addTransactionInput.fromCardId
                  ) || null
                }
                options={fromCards}
                onChange={fromCardSelectHandler}
              />
            </div>
            <div className="mb-5">
              <label
                className="form-label"
                style={{
                  color: "#677788",
                  fontSize: "0.75rem",
                }}
              >
                کارت بانکی مربوطه
              </label>
              <CreateSelect
                value={
                  toCards.find(
                    (c) => +c.value === +addTransactionInput.toCardId
                  ) || null
                }
                isDisabled={toCards.length === 0}
                options={toCards}
                onChange={toCardSelectHandler}
              />
            </div>
            <div className="d-flex justify-content-evenly ">
              <CustomButton
                className="w-25 d-flex justify-content-center"
                color="danger"
                onClick={backButton}
              >
                بستن
              </CustomButton>
              <CustomButton
                className="w-25 d-flex justify-content-center"
                color="primary"
                btnType="submit"
                onClick={submitTransaction}
              >
                ثبت
              </CustomButton>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <Modal
        show={show === TransactionModalsTypes.AddCard}
        onHide={() => setShow(TransactionModalsTypes.AddTransaction)}
      >
        <Modal.Header closeButton>
          <Modal.Title>افزودن کارت بانکی</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="row row-cols-1 pb-3">
            <div className="mb-4">
              <label
                className="form-label"
                style={{
                  color: "#677788",
                  fontSize: "0.75rem",
                }}
              >
                بانک مربوطه
              </label>
              <Select
                value={banks.filter((b) => +b.value === +addCardInput.bankId)}
                options={banks}
                onChange={bankSelectHandler}
              />
            </div>
            <CustomInput
              inputContainer="mb-4"
              label="شماره حساب"
              type="number"
              inputValue={"" + addCardInput.accountNumber}
              // @ts-ignore
              onChangeFunc={AccountNumberInputHandler}
            />
            <CustomInput
              inputContainer="mb-4"
              label="شماره کارت"
              type="number"
              inputValue={"" + addCardInput.cardNumber}
              textErr={addCardInput.cardNumberError}
              // @ts-ignore
              onChangeFunc={cardNumberInputHandler}
            />
            <CustomInput
              inputContainer="mb-4"
              label="شماره شبا"
              type="number"
              inputValue={"" + addCardInput.shebaNumber}
              textErr={addCardInput.shebaNumberError}
              // @ts-ignore
              onChangeFunc={shebaNumberInputHandler}
            />
            <div className="d-flex justify-content-evenly">
              <CustomButton
                className="w-25 d-flex justify-content-center"
                color="danger"
                onClick={addCardBackButton}
              >
                بستن
              </CustomButton>
              <CustomButton
                className="w-25 d-flex justify-content-center"
                color="primary"
                btnType="submit"
                onClick={submitCard}
              >
                ثبت
              </CustomButton>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export { DetailModal, TransactionModal };
